import { render } from "./QuestionOrder.vue?vue&type=template&id=18c57690"
import script from "./QuestionOrder.vue?vue&type=script&lang=js"
export * from "./QuestionOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__